<template>
  <section class="w-100">
    <div class="wrapper">
      <CContainer class="py-4">
        <CRow class="pageManageBalance">
          <CCol sm="12">
            <PageHeader
              class="border-0 content-center"
              :title="$t(`general.components.header-page.manage-balance`)"
              pathName="home"
              :subTitle="$t('balance.component.currentBalance.subtitle')"
            />
          </CCol>
          <CCol sm="12" v-if="loading" class="vh-100">
            <div class="d-flex justify-content-center align-items-center" style="height: 30vh">
              <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
            </div>
          </CCol>
          <CCol v-else>
            <CRow>
              <CCol v-if="messages.length" sm="12">
                <transition name="fade">
                  <MenssageAlert :messages="messages" />
                </transition>
              </CCol>
              <CContainer>
                <CRow>
                  <CCol sm="12" md="12" class="pr-4">
                    <!-- <h3 class="subtitlePage font-weight-normal">{{ $t('balance.component.currentBalance.title') }}</h3> -->
                    <NewBalance :balances="currentBalance" :list="false" @channelSelected="channelSelected" />
                  </CCol>
                  <CCol sm="12" lg="6" class="pl-4 mt-4 offset-lg-3">
                    <transition name="fade" v-if="channel == 'sms'">
                      <CCard>
                        <CCardHeader class="p-4 bg-gray-200">
                          <h5>{{ $t('balance.component.currentBalanceCountries.title') }}</h5>
                        </CCardHeader>
                        <BalanceCountry :balances="balanceSMS" :value="channel" />
                      </CCard>
                    </transition>
                  </CCol>
                </CRow>
              </CContainer>
            </CRow>
            <CRow class="mt-5" v-if="isVisible">
              <CCol sm="12" class="d-flex justify-content-center">
                <h3 class="font-4xl pb-2">
                  {{ $t(`balance.component.tabsPacks.title-${channel}`) }}
                </h3>
              </CCol>

              <CCol sm="12" class="d-flex justify-content-center py-5 h4 font-weight-normal" v-if="channel == 'sms' && countrySelected == null">
                {{ $t('balance.components.balaceTabPacks.text-select-destination') }}
              </CCol>

              <CCol sm="12" class="d-flex justify-content-center py-5" v-else-if="!hasPayAsYouGoRouteParams && !isPayAsYouGoPlan">
                {{ $t('balance.components.balaceTabPacks.addOnBuy.oneShot') }}

                <CSwitch
                  class="mx-1 mx-3"
                  color="primary"
                  shape="pill"
                  size="lg"
                  checked
                  :value="addOnRecurrenceType"
                  @update:checked="(val) => addOnRecurrenceTypeHandler(val)"
                />
                {{ $t('balance.components.balaceTabPacks.addOnBuy.discount') }}
              </CCol>

              <BalanceTabPacks
                :channel="channel"
                :countrySelected="countrySelected"
                :countryPack="countryPack"
                :packs="handlerPacks"
                :countryCurrentBalance="countryCurrentBalance"
                :addOnRecurrenceType="addOnRecurrenceType"
                @setCountry="setCountry"
                :loading="loadingPacks"
              >
              </BalanceTabPacks>
            </CRow>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    <div class="mt-5 pt-5">
      <CContainer>
        <CRow>
          <CCol sm="12" md="8" class="offset-md-2" @click="showContactForm">
            <NeedSomething
              :title="$t(`general.components.needSomething.page.manage-balance.title`)"
              :description="$t(`general.components.needSomething.page.manage-balance.description`)"
              :textButton="$t(`general.components.needSomething.page.manage-balance.button`)"
            />
            <ContactForm v-show="isContactForm" @sentSuccessfully="handleContactFormSent" />
          </CCol>
          <CCol sm="12" md="8" class="offset-md-2 my-5 py-5">
            <div class="text-center mt-5 mb-5">
              <h2 class="h1 font-weight-bold">
                {{ $t(`general.balance.manage-balance.questions.title`) }}
              </h2>
              <p class="mt-4 h5 text-gray-600 font-weight-normal" v-html="$t(`general.balance.manage-balance.questions.subTitle`)"></p>
            </div>

            <div class="mt-5">
              <Questions class="mt-5" contentName="faq-general" />
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  </section>
</template>

<script>
import ContactForm from './../components/ContactForm.vue'
import PageHeader from '@/components/PageHeader.vue'
import NewBalance from '@/components/NewBalance.vue'
import Questions from '@/components/Questions.vue'
import NeedSomething from '@/components/NeedSomething.vue'
import BalanceCountry from '@/components/BalanceCountry.vue'
import BalanceTabPacks from './../components/BalanceTabPacks.vue'
import { enumChannelType } from '@/utils/enumsUtils.js'
import services from '@/services.js'

const addOnTypeCode = {
  email: 'addonemails',
  sms: 'addonsms',
}

export default {
  name: 'ManageBalance',
  components: {
    PageHeader,
    NewBalance,
    BalanceCountry,
    BalanceTabPacks,
    NeedSomething,
    Questions,
    ContactForm,
  },

  data() {
    return {
      isContactForm: false,
      loading: false,
      organizationId: null,
      itemsPack: [],
      countryPack: [],
      countrySelected: null,
      channel: 'email',
      messages: [],
      // addOnRecurrenceType - 1 add plan - 2 one shot
      addOnRecurrenceType: 1,
      loadingPacks: false,
    }
  },

  created() {
    this.organizationId = this.$route.params.organizationId
    this.getBalance()
    this.getCountryDefault()
  },

  mounted() {
    // this.getCountryOrganization()
    this.getPackAddons(addOnTypeCode[this.channel])

    if (this.hasPayAsYouGoRouteParams || this.isPayAsYouGoPlan) {
      this.addOnRecurrenceType = 2
    }
  },

  computed: {
    balanceSMS() {
      return this.$store.getters['backOffice/balanceSms'] || []
    },

    currentBalance() {
      let balance = JSON.parse(JSON.stringify(this.$store.getters['backOffice/totalCurrentBalance'])) || []

      return (
        balance.length &&
        balance.map((item) => {
          return {
            ...item,
            checked: item.channel == this.channel ? true : false,
          }
        })
      )
    },

    countryCurrentBalance() {
      if (this.balanceSMS.length == 0) {
        return 0
      }
      if (this.balanceSMS.length && this.channel == 'sms' && this.countrySelected) {
        const country = this.balanceSMS.filter((item) => {
          let a = item.countryId || ''
          let b = this.countrySelected

          if (a.toUpperCase() == b.toUpperCase()) {
            return item
          }
        })[0]

        return country?.balance || 0
      }
      var defaultCountry = this.balanceSMS.find((item) => item.countryId === 'PT')
      return defaultCountry?.balance || 0
    },

    handlerPacks() {
      if (this.channel == 2 && this.countrySelected) {
        return this.itemsPack.filter((item) => {
          let a = item.countryId || ''
          let b = this.countrySelected

          if (a.toUpperCase() == b.toUpperCase()) {
            return item
          }
        })
      }

      return this.itemsPack
    },

    hasPayAsYouGoRouteParams() {
      return Boolean(this.$route.query.selectedPlanId)
    },

    isPayAsYouGoPlan() {
      return this.$store.state.auth.session.organization?.planType == 5
    },

    isVisible() {
      const NO_OWN_BALANCE = 1
      const OWN_BALANCE_DEPENDENT = 2
      const OWN_BALANCE_INDEPENDENT = 3
      const STANDARD = 2
      const PAY_AS_YOU_GO = 5

      if (
        (this.$store.state.auth.session.organization?.organizationBalanceConfigType == OWN_BALANCE_INDEPENDENT &&
          (this.$store.state.auth.session.organization?.planType == STANDARD ||
            this.$store.state.auth.session.organization?.planType == PAY_AS_YOU_GO)) ||
        this.hasPayAsYouGoRouteParams
      ) {
        return true
      }

      return false
    },
  },

  methods: {
    handleContactFormSent() {
      this.isContactForm = false
    },
    showContactForm() {
      this.isContactForm = true
    },
    addOnRecurrenceTypeHandler(val) {
      return (this.addOnRecurrenceType = val ? 1 : 2)
    },

    getBalance() {
      this.$store
        .dispatch('backOffice/getBalances', { targetOrganizationId: this.organizationId })
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },

    getPackAddons(addOn) {
      this.loadingPacks = true

      if (addOn == 'addonsms' && this.countrySelected == null) {
        this.loadingPacks = false
        this.itemsPack = []
        return
      }

      const planId = this.$route.query.selectedPlanId || this.$store.state.auth.session.organization.planId

      services
        .getPackAddons(addOn, { planId, countryId: this.countrySelected })
        .then(({ data }) => {
          const sortedDataByBalanceASC = data.data.sort((a, b) => a.balance - b.balance)

          if (enumChannelType(this.channel) != 'sms') {
            this.itemsPack = sortedDataByBalanceASC
            return
          }

          this.itemsPack = this.handlerSmsPack(sortedDataByBalanceASC)
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.data.message || 'erro',
          })
        })
        .finally(() => {
          this.loadingPacks = false
        })
    },

    nameTypePack(type) {
      return enumChannelType(type)
    },

    handlerSmsPack(packs) {
      this.countryPack = this.getCountries(packs)
      return packs
    },

    getCountries(packs) {
      return packs.reduce((acc, cur) => {
        if (!acc.includes(cur.countryId)) acc.push(cur.countryId)
        return acc
      }, [])
    },

    channelSelected(channel) {
      this.getPackAddons(addOnTypeCode[channel])
      this.channel = channel
      this.countrySelected = null
    },

    setCountry(country) {
      this.countrySelected = country || null
      this.getPackAddons(addOnTypeCode[this.channel])
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'selectedCountry', data: country })
    },

    getCountryOrganization() {
      services.getBasicInfo(this.$store.state.auth.user.id).then((res) => {
        this.countrySelected = res.data.data.country || null
      })
    },

    getCountryDefault() {
      services
        .defaultCountryAddOnSms(this.organizationId)
        .then(({ data }) => {
          this.countrySelected = data.data
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.data.message || 'erro',
          })
        })
        .finally(() => {
          this.loadingPacks = false
        })
    },
  },
}
</script>

<style lang="scss">
.wrapper {
  background: var(--white);
}
.c-switch {
  .c-switch-input:not(:checked) + .c-switch-slider,
  .c-switch-input:checked + .c-switch-slider {
    border-color: transparent;
    background-color: var(--primary);
    border: 0;
  }
}
</style>
